import type { StreamServer } from '../types';

export function normalizeServerUrl(input: string): string {
  const t = input.trim();
  if (!t) return '';
  if (!/^https?:\/\//i.test(t)) {
    return `http://${t}`.replace(/\/+$/, '');
  }
  return t.replace(/\/+$/, '');
}

export function serversDuplicate(
  list: StreamServer[],
  server: string,
  username: string,
  excludeId?: string,
): boolean {
  const s = normalizeServerUrl(server).toLowerCase();
  const u = username.trim().toLowerCase();
  return list.some(
    (x) =>
      x.id !== excludeId &&
      normalizeServerUrl(x.server).toLowerCase() === s &&
      x.username.trim().toLowerCase() === u,
  );
}
